import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import { MessageCircle, Mail, MapPin, Phone } from 'lucide-react';

const ContactSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-navy-900 mb-4">{t.contact.title}</h2>
          <p className="text-xl text-gold-600 font-medium">{t.contact.subtitle}</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-cream-50 rounded-2xl p-12 border border-gray-200 shadow-lg">
            <h3 className="text-3xl font-bold text-navy-900 mb-8 text-center">{t.contact.info.title}</h3>
            <div className="space-y-6">
              <div className="flex items-center gap-6 p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="p-4 bg-green-600 rounded-xl">
                  <Phone size={32} className="text-white" />
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">{t.contact.info.telephone}</div>
                  <a 
                    href={`tel:${t.contact.info.telephoneValue.replace(/\s/g, '')}`}
                    className="text-xl font-bold text-navy-900 hover:text-gold-600 transition-colors"
                  >
                    {t.contact.info.telephoneValue}
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-6 p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="p-4 bg-navy-700 rounded-xl">
                  <MessageCircle size={32} className="text-white" />
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">{t.contact.info.whatsapp}</div>
                  <a 
                    href="https://wa.me/85296586641"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xl font-bold text-navy-900 hover:text-gold-600 transition-colors"
                  >
                    +852 9658 6641
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-6 p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="p-4 bg-gold-600 rounded-xl">
                  <Mail size={32} className="text-white" />
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">{t.contact.info.email}</div>
                  <a 
                    href="mailto:cs@keenwisdom.com"
                    className="text-xl font-bold text-navy-900 hover:text-gold-600 transition-colors"
                  >
                    {t.contact.info.emailValue}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-6 p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
                <div className="p-4 bg-blue-600 rounded-xl">
                  <MapPin size={32} className="text-white" />
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">{t.contact.info.address}</div>
                  <a 
                    href={t.contact.info.addressLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-lg font-semibold text-navy-900 hover:text-gold-600 transition-colors block leading-relaxed"
                  >
                    {t.contact.info.addressValue}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;